// src/components/Homepage.js
import React, { useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import Button from './ui/Button';
import { Link } from "react-router-dom";
import { getHomepageData } from '../Api';

// Import all images from src/assets (used as fallbacks)
import qualityControl from '../assets/images/homepage/quality-control-2.jpg';
import hero1 from '../assets/images/homepage/hero-1.jpg';
import hero2 from '../assets/images/homepage/hero-2.jpg';
import hero3 from '../assets/images/homepage/hero-3.jpg';
import customizedSolutions from '../assets/images/homepage/customized-solutions-2.jpg';
import qualityControlImg from '../assets/images/homepage/quality-control.jpg';
import bottomChef from '../assets/images/homepage/bottom.jpg';
import doughImg from '../assets/images/homepage/dough.jpg';
import freshDaily from '../assets/images/homepage/fresh daily.jpg';
import goodMorning from '../assets/images/homepage/good morning.jpg';
import image7 from '../assets/images/homepage/Image7.jpg';
import image8 from '../assets/images/homepage/Image8.jpg';
import image9 from '../assets/images/homepage/Image9.jpg';

// tag/label images
import globalExpertise from '../assets/images/homepage/goloble expertise.png';
import statsAchievements from '../assets/images/homepage/stats and achievements.png';
import rdInnovation from '../assets/images/homepage/r&d and innovation.png';
import tailorMade from '../assets/images/homepage/tailor made solutions.png';
import qualityConsistency from '../assets/images/homepage/quality&consistensy.png';
import sustainabilityFocus from '../assets/images/homepage/sustainability focus.png';
import technicalSupport from '../assets/images/homepage/technical support.png';
import titleHolder from '../assets/images/homepage/Title holder.png';
import stremingLogo from '../assets/images/homepage/streming-logo.png';
import imagePlaceholder from '../assets/images/homepage/partnership.jpg';
import testimonials from '../assets/images/homepage/Testimonials.png';


// logo
import statsLogo from '../assets/logo/Stats.png';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://enessafoods.com';

/**
 * Normalize image paths returned by the API:
 * - If imagePath starts with 'http' -> return as-is
 * - If it starts with '/' -> prefix with API_BASE_URL (e.g. /media/...)
 * - Otherwise assume it's already a local imported module / valid URL -> return as-is
 */
const getFullImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http')) return imagePath;
  // Remove /api from URL for media files
  const baseUrl = API_BASE_URL.replace('/api', '');
  return `${baseUrl}${imagePath}`;
};

const Homepage = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [homepageData, setHomepageData] = useState({
    banners: [],
    testimonials: [],
    testimonial_stats: [],
    stats: [],
    blogs: []
  });
  const [loading, setLoading] = useState(true);

  // Local fallback banner images (imported assets)
  const fallbackBannerImages = [qualityControl, hero2, hero3];

  // Fallback data (used on error or if API returns empty)
  const fallbackData = {
    banners: [{
      title: "Unlock the Full Potential of Baking with us",
      subtitle: "Trusted by professionals across India, we bring global expertise and tailored solutions to bakeries of every size.",
      subheading: "🌐 global expertise",
      features_section: [
        'Global experience with deep industry knowledge',
        'Trusted name in the Indian baking industry',
        'Serving artisan bakeries to large-scale operations'
      ],
      banner_image1: qualityControl,
      banner_image2: hero2,
      banner_image3: hero3
    }],
    testimonials: [
      { quote: "Enessa's bread improvers have transformed our production. The consistency is remarkable.", name: "Rajesh Kumar", position: "Head Baker, Mumbai" },
      { quote: "The technical support team helped us optimize our recipe and reduce costs by 20%.", name: "Priya Sharma", position: "Production Manager" },
      { quote: "Quality ingredients, expert guidance, and reliable supply. Everything we need.", name: "Amit Patel", position: "Owner, Premium Bakery" }
    ],
    testimonial_stats: [
      { number: '500+', label: 'Happy Customers' },
      { number: '5k+', label: 'Hours spent on innovation' },
      { number: '4.8', label: 'Satisfactory Review Rate' }
    ],
    stats: [],
    blogs: [
      { category: 'Sustainability', time: '8 min read', title: 'Sustainable Baking Practices Every Modern Bakery Should Adopt', image: doughImg },
      { category: 'Innovation', time: '15 min read', title: 'The Rise of Clean-Label Baking: How to Stay Ahead', image: freshDaily },
      { category: 'Production', time: '5 min read', title: '5 Ways to Improve Bread Quality Without Increasing Costs', image: goodMorning }
    ]
  };

  useEffect(() => {
    console.log("Homepage component mounted!");

    let mounted = true;

    const fetchHomepage = async () => {
      console.log("inside homepage fetch");

      setLoading(true);
      try {
        console.log("inside try block");

        const data = await getHomepageData();



        if (!mounted) return;

        // Normalize banners (handle images)
        const banners = Array.isArray(data?.banners) && data.banners.length > 0
          ? data.banners.map(b => ({
              ...b,
              // features_section may be a string with \r\n; keep as string here and parse later
              
              features_section: b.features_section || '',
              banner_image1: getFullImageUrl(b.banner_image1),
              banner_image2: getFullImageUrl(b.banner_image2),
              banner_image3: getFullImageUrl(b.banner_image3)
            }))
          : fallbackData.banners.map(b => ({
              ...b,
              features_section: Array.isArray(b.features_section) ? b.features_section.join('\n') : b.features_section,
              banner_image1: getFullImageUrl(b.banner_image1),
              banner_image2: getFullImageUrl(b.banner_image2),
              banner_image3: getFullImageUrl(b.banner_image3)
            }));

        const testimonials = Array.isArray(data?.testimonials) && data.testimonials.length > 0 
          ? data.testimonials.map(testimonial => {
              const photoUrl = getFullImageUrl(testimonial.photo);
              const logoUrl = getFullImageUrl(testimonial.company_logo);
              return {
                ...testimonial,
                photo: photoUrl,
                company_logo: logoUrl
              };
            })
          : fallbackData.testimonials;
        const testimonial_stats = Array.isArray(data?.testimonial_stats) && data.testimonial_stats.length > 0 ? data.testimonial_stats : fallbackData.testimonial_stats;
        const stats = Array.isArray(data?.stats) && data.stats.length > 0 ? data.stats : fallbackData.stats;

        const allBlogs = Array.isArray(data?.blogs) && data.blogs.length > 0
          ? data.blogs.map(blog => ({
              ...blog,
              image: getFullImageUrl(blog.image)
            }))
          : fallbackData.blogs.map(b => ({ ...b, image: getFullImageUrl(b.image) }));
        
        const blogs = allBlogs.filter(blog => blog.to_be_featured || blog.is_featured);

        setHomepageData({
          banners,
          testimonials,
          testimonial_stats,
          stats,
          blogs
        });
      } catch (err) {
        console.error('Error fetching homepage data:', err);
        if (!mounted) return;
        setHomepageData(fallbackData);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchHomepage();

    return () => {
      mounted = false;
    };
  }, []);

  // Choose the active banner (first active or first available)
  const activeBanner = (homepageData.banners || []).find(b => b.is_active !== false) || (homepageData.banners && homepageData.banners[0]) || fallbackData.banners[0];
  const bannerImages = activeBanner ? [
    activeBanner.banner_image1,
    activeBanner.banner_image2,
    activeBanner.banner_image3
  ].filter(Boolean) : fallbackBannerImages;
  
  // Debug logging
  console.log('Active banner:', activeBanner);
  console.log('Banner images:', bannerImages);
  console.log('API_BASE_URL:', API_BASE_URL);

  const nextImage = () => setCurrentImageIndex((prev) => (bannerImages.length ? (prev + 1) % bannerImages.length : 0));
  const prevImage = () => setCurrentImageIndex((prev) => (bannerImages.length ? (prev - 1 + bannerImages.length) % bannerImages.length : 0));

  // Auto-scroll functionality
  useEffect(() => {
    if (bannerImages.length <= 1) return;
    
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % bannerImages.length);
    }, 4000); // Change image every 4 seconds

    return () => clearInterval(interval);
  }, [bannerImages.length]);

  // Parse features_section string into an array (robust to \r\n or \n)
  const getFeaturesArray = (banner) => {
    if (!banner) return [];
    const raw = (banner.features_section ?? banner.features_section) || '';
    if (Array.isArray(raw)) return raw;
    return raw
      .split(/\r?\n/)
      .map(s => s.trim())
      .filter(Boolean);
  };

  return (
    <div className="min-h-screen bg-white lg:bg-cream">
      <Header />

      {/* Hero Section */}
      <section className="py-12 bg-white lg:py-16 lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="flex flex-col items-center gap-8 lg:flex-row-reverse lg:gap-16">
            {/* Image Section */}
            <div className="relative flex-1 w-full max-w-xl lg:max-w-2xl">
              <div className="absolute w-64 h-64 rounded-full -top-8 -right-8 bg-primary/5 blur-3xl"></div>

              <div className="relative">
                {loading ? (
                  <div className="w-full h-[400px] lg:h-[500px] bg-gray-200 rounded-4xl animate-pulse"></div>
                ) : (
                  <img
                    src={bannerImages[currentImageIndex] || fallbackBannerImages[0]}
                    alt="Enessa Foods Bakery Solutions"
                    className="w-full h-[400px] lg:h-[500px] object-cover rounded-4xl shadow-xl transition-all duration-500"
                    onError={(e) => {
                      console.error('Banner image failed to load:', e.target.src);
                      // Fallback to local image if API image fails
                      if (e.target.src.includes('enessafoods.com')) {
                        e.target.src = fallbackBannerImages[currentImageIndex];
                      }
                    }}
                    onLoad={() => console.log('Banner image loaded:', bannerImages[currentImageIndex])}
                  />
                )}

                {/* Carousel Controls */}
                <div className="absolute flex gap-3 bottom-6 right-6">
                  <button
                    onClick={prevImage}
                    className="flex items-center justify-center text-2xl font-bold transition-all rounded-full shadow-lg bg-white/95 hover:bg-white w-11 h-11 hover:scale-110 text-text-primary backdrop-blur-sm"
                    aria-label="Previous image"
                  >
                    ‹
                  </button>
                  <button
                    onClick={nextImage}
                    className="flex items-center justify-center text-2xl font-bold transition-all rounded-full shadow-lg bg-white/95 hover:bg-white w-11 h-11 hover:scale-110 text-text-primary backdrop-blur-sm"
                    aria-label="Next image"
                  >
                    ›
                  </button>
                </div>

                {/* Carousel Dots */}
                <div className="absolute flex gap-2 -translate-x-1/2 bottom-6 left-1/2">
                  {bannerImages.map((_, idx) => (
                    <button
                      key={idx}
                      onClick={() => setCurrentImageIndex(idx)}
                      className={`w-2 h-2 rounded-full transition-all ${idx === currentImageIndex ? 'bg-primary w-6' : 'bg-white/60'}`}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Text Content */}
            <div className="flex-1 max-w-xl">
              <div className="mb-3">
                <img src={globalExpertise} alt="Global Expertise" className="mb-1" />
              </div>

              {/* Hero Heading */}
              <h1 className="mb-5 leading-tight font-heading text-heading-md lg:text-heading-xl text-text-primary">
                {loading ? (
                  <div className="h-16 bg-gray-200 rounded animate-pulse"></div>
                ) : (
                  activeBanner?.title || "Unlock the Full Potential of Baking with us"
                )}
              </h1>

              {/* Body Text */}
              <p className="leading-normal font-body text-body-md lg:text-body-lg text-text-primary mb-7">
                {loading ? (
                  <div className="h-20 bg-gray-200 rounded animate-pulse"></div>
                ) : (
                  activeBanner?.subtitle || "Trusted by professionals across India, we bring global expertise and tailored solutions to bakeries of every size."
                )}
              </p>

              {/* Features Box */}
              <div className="p-5 bg-white lg:p-6 rounded-2xl shadow-soft mb-7">
                <ul className="space-y-3">
                  {loading ? (
                    Array.from({ length: 3 }).map((_, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <div className="w-5 h-5 bg-gray-200 rounded animate-pulse mt-0.5"></div>
                        <div className="flex-1 h-4 bg-gray-200 rounded animate-pulse"></div>
                      </li>
                    ))
                  ) : (
                    getFeaturesArray(activeBanner).map((item, idx) => (
                      <li key={idx} className="flex items-start gap-3 text-text-secondary font-body text-body-sm lg:text-body-md">
                        <svg className="w-5 h-5 lg:w-6 lg:h-6 text-primary flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                        </svg>
                        <span>{item}</span>
                      </li>
                    ))
                  )}
                </ul>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-wrap gap-3">
                <Link to="/contact">
                  <Button variant="primary" size="medium">Contact Us</Button>
                </Link>
                <Link to="/services">
                  <Button variant="secondary" size="medium">View Services</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partnership Section */}
      <section className="py-16 bg-white lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="flex flex-col items-center gap-12 lg:flex-row">
            <div className="flex-1">
              <img 
                src={imagePlaceholder} 
                alt="Partnership"
                className="w-full h-[500px] object-cover rounded-3xl shadow-xl"
              />
            </div>
            <div className="flex-1 max-w-xl">
              <div className="mb-3 text-xs font-semibold tracking-wider uppercase text-primary">
                Partnership
              </div>
              <h2 className="mb-6 leading-tight font-heading text-heading-sm lg:text-heading-md text-text-primary">
                BECOME A PARTNER AT NO RISK
              </h2>
              <p className="mb-8 leading-normal font-body text-body-md text-text-primary">
                Enessa Foods exports premium, performance-driven Bakery Improver, Enzymes and ingredients from India to industrial bakeries and food manufacturers across the Middle East and Africa Region—delivering consistent quality backed by R&D, application trials, and dedicated technical support.
              </p>
              <div className="flex flex-wrap gap-3">
                <Link to="/contact"><Button variant="primary" size="medium">Contact Us</Button></Link>
                <Link to="/products"><Button variant="secondary" size="medium">Our Products</Button></Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats and achievement Section */}
      <section className="py-16 bg-white lg:py-20 lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="mb-12 text-center">
            <div className="mb-2 font-semibold tracking-wider uppercase font-body text-body-xs text-primary">
              <img src={statsAchievements} alt="Stats and Achievements" className="mx-auto mb-12" />
            </div>
            <h2 className="mb-4 font-heading text-heading-md lg:text-heading-lg text-text-primary">
              From Product Launches to Partner Growth<br className="hidden md:block"/>We Cover Everything.
            </h2>
          </div>

          {homepageData.stats && homepageData.stats.length > 0 ? (
            <div className="text-center mobile-stack md:grid md:grid-cols-4">
              {homepageData.stats.map((stat) => (
                <div key={stat.id ?? stat.label}>
                  <div className="mb-2 text-4xl font-bold font-heading text-primary">{stat.number}</div>
                  <p className="font-body text-body-sm text-text-secondary">{stat.label}</p>
                </div>
              ))}
            </div>
          ) : (
            <div>
              <img src={statsLogo} alt="Statistics" className="w-full" />
            </div>
          )}
        </div>
      </section>

      {/* Image + Text Alternating Sections */}
      {[
        {
          tag: rdInnovation,
          title: 'Stay Ahead with Cutting-Edge Baking Solutions',
          description: 'Our team of experts is constantly researching new ingredient solutions and baking technologies to keep you at the cutting edge of the industry. From ultrasonic cutting technology to clean-label improvers, innovation drives everything we do.',
          image: hero1,
          buttons: [
            { label: 'Contact Us', path: '/contact' },
            { label: 'View Innovations', path: '/innovation' },
          ],
          reverse: false,
        },
        {
          tag: tailorMade,
          title: 'Customized to Fit Your Unique Needs',
          description: 'We provide customized formulations and recipe development to meet your unique production requirements. Enessa Foods offers tailor-made premixes and improvers that address local market trends and individual client needs.',
          image: hero2,
          buttons: [
            { label: 'Contact Us', path: '/contact' },
            { label: 'View Services', path: '/services' },
          ],
          reverse: true,
        },
        {
          tag: qualityConsistency,
          title: 'Superior Ingredients. Consistent Results',
          description: 'We use only the finest ingredients and enforce rigorous quality control, ensuring superior product quality and consistency in every batch. Our solutions help standardize your output and improve process efficiency.',
          image: hero3,
          buttons: [
            { label: 'Contact Us', path: '/contact' },
            { label: 'View Products', path: '/products' },
          ],
          reverse: false,
        },
        {
          tag: sustainabilityFocus,
          title: 'Baking for a Greener Future',
          description: 'Enessa Foods is committed to eco-friendly practices – from responsible sourcing to developing clean-label products that eliminate harmful additives. We help you bake sustainably without compromising on taste or quality.',
          image: customizedSolutions,
          buttons: [
            { label: 'Contact Us', path: '/contact' },
            { label: 'View Blogs', path: '/blogs' },
          ],
          reverse: true,
        },
        {
          tag: technicalSupport,
          title: 'Expert Guidance at Every Step',
          description: 'Beyond ingredients, we provide exceptional customer support and technical guidance. Our experienced baking consultants assist with process optimization, equipment integration & staff training, ensuring you get the most out of our products. ',
          image: qualityControlImg,
          buttons: [
            { label: 'Contact Us', path: '/contact' },
            { label: 'About Us', path: '/about' },
          ],
          reverse: false,
        },
      ].map((section, idx) => (
        <section key={idx} className={`py-12 lg:py-16 bg-white lg:bg-cream`}>
          <div className="px-6 mx-auto max-w-7xl lg:px-8">
            <div className={`flex flex-col ${section.reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-8 lg:gap-16`}>
              {/* Text Section */}
              <div className="flex-1 max-w-xl">
                <img src={section.tag} alt={section.title} className="mb-4" />
                <h3 className="mb-4 leading-tight font-heading text-heading-sm lg:text-heading-md text-text-primary">
                  {section.title}
                </h3>
                <p className="mb-6 leading-normal font-body text-body-md text-text-primary">
                  {section.description}
                </p>
                <div className="flex flex-wrap gap-3">
                  {section.buttons.map((btn, i) => (
                    <Link key={i} to={btn.path}>
                      <Button variant={i === 0 ? 'primary' : 'secondary'} size="medium">
                        {btn.label}
                      </Button>
                    </Link>
                  ))}
                </div>
              </div>

              {/* Image Section */}
              <div className="flex-1 max-w-xl">
                <img
                  src={section.image}
                  alt={section.title}
                  className="object-cover w-full shadow-lg h-80 lg:h-96 rounded-3xl"
                />
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* Why Enessa Foods Section
      <section className="py-20 bg-white lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="mb-12 text-center">
            <img 
              src={titleHolder} 
              alt="Why Enessa Foods" 
              className="mx-auto mb-12" 
            />
            <h3 className="mb-4 font-heading text-heading-lg text-text-primary">
              Unmatched Quality, Innovation & Support<br/>For Your Bakery's Success
            </h3>
            <p className="max-w-3xl mx-auto font-body text-body-md text-text-primary">
              Discover the perfect combination of premium ingredients, innovative solutions and dedicated support that help your bakery thrive.
            </p>
          </div>

          {/* Bento Grid Layout *
          <div className="grid grid-cols-1 gap-4 md:grid-cols-6">

            <div className="p-8 bg-white md:col-span-2 rounded-3xl">
              <div className="mb-2 font-bold uppercase text-primary font-body text-body-xs">PREMIUM PRODUCT</div>
              <h4 className="mb-3 font-heading text-heading-xs text-text-primary">Superior Quality</h4>
              <p className="mb-4 leading-normal font-body text-body-sm text-text-primary">
                Enhance your baked products with premium ingredients for better texture, volume and taste.
              </p>
               <img 
              src={image7} 
              alt="superior Quality" 
              className="mx-auto mb-12" 
            />
              <Link to="/products" className="font-medium text-primary font-body text-body-sm hover:underline">
                Our Products →
              </Link>
            </div>

            <div className="p-8 bg-white md:col-span-3 rounded-3xl">
              <div className="mb-2 font-bold uppercase text-primary font-body text-body-xs">STREAMLINING</div>
              <h4 className="mb-3 font-heading text-heading-xs text-text-primary">Improved Processability</h4>
              <p className="mb-4 leading-normal font-body text-body-sm text-text-primary">
                Achieve smoother operations and reduce wastage with our process-improving solutions.
              </p>
               <img 
              src={image8} 
              alt="improved processability" 
              className="mx-auto mb-12" 
            />
              <Link to="/innovation" className="font-medium text-primary font-body text-body-sm hover:underline">
                Our Innovations →
              </Link>
            </div>

            <div className="flex flex-col justify-between p-8 bg-white md:col-span-1 rounded-3xl">
              <div>
                <div className="mb-2 font-bold uppercase text-primary font-body text-body-xs">COST-EFFECTIVE</div>
                <h4 className="mb-3 font-heading text-heading-xs text-text-primary">Pocket-friendly</h4>
                <p className="mb-4 leading-normal font-body text-body-sm text-text-primary">
                Lower your costs with competitive pricing and ingredients that improve yield (e.g. gluten replacers), all without compromising quality.
              </p>
               <img 
              src={image9} 
              alt="pocket-friendly" 
              className="mx-auto mb-12" 
            />
              </div>
              <Link to="/services" className="font-medium text-primary font-body text-body-sm hover:underline">
                Our Services →
              </Link>
            </div>

            <div className="p-8 bg-white md:col-span-4 rounded-3xl">
              <div className="mb-2 font-bold uppercase text-primary font-body text-body-xs">ECO-FRIENDLY</div>
              <h4 className="mb-3 font-heading text-heading-xs text-text-primary">Sustainability</h4>
              <p className="mb-4 leading-normal font-body text-body-sm text-text-primary">
                Minimize your environmental footprint with our eco-friendly ingredients and practices.
              </p>
              <Link to="/blogs" className="font-medium text-primary font-body text-body-sm hover:underline">
                Blogs →
              </Link>
            </div>

            <div className="p-8 bg-white md:col-span-2 rounded-3xl">
              <div className="mb-2 font-bold uppercase text-primary font-body text-body-xs">EXPERT SUPPORT</div>
              <h4 className="mb-3 font-heading text-heading-xs text-text-primary">Dedicated Support</h4>
              <p className="mb-4 leading-normal font-body text-body-sm text-text-primary">
                Enjoy excellent service and technical support from our responsive team of baking experts.
              </p>
              <Link to="/about" className="font-medium text-primary font-body text-body-sm hover:underline">
                About Us →
              </Link>
            </div>
          </div>
        </div>
      </section> */}

      {/* Testimonials */}
      <section className="py-20 bg-white lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="mb-12 text-center">
            <img 
              src={testimonials} 
              alt="Why Enessa Foods" 
              className="mx-auto mb-12" 
            />
            <h2 className="mb-4 font-heading text-heading-lg text-text-primary">What Our Clients Say</h2>
            <p className="max-w-3xl mx-auto font-body text-body-md text-text-secondary">
              Hear from the professionals who trust Enessa Foods to elevate their baking.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6 mb-12 md:grid-cols-3">
            {loading ? (
              Array.from({ length: 3 }).map((_, idx) => (
                <div key={idx} className="animate-pulse">
                  <div className="p-6 mb-4 bg-white rounded-2xl shadow-soft">
                    <div className="h-20 bg-gray-200 rounded"></div>
                  </div>
                  <div className="p-4 bg-transparent border-2 border-primary/20 rounded-2xl">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
                      <div className="flex-1">
                        <div className="h-4 mb-2 bg-gray-200 rounded"></div>
                        <div className="w-3/4 h-3 bg-gray-200 rounded"></div>
                      </div>
                    </div>
                    <div className="w-16 h-8 bg-gray-200 rounded"></div>
                  </div>
                </div>
              ))
            ) : (
              homepageData.testimonials.map((testimonial) => (
                <div key={testimonial.id ?? testimonial.name} className="relative">
                  {/* First Sub Card - Feedback */}
                  <svg width="118" height="20" viewBox="0 0 118 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto mb-4">
                    <path d="M8.19994 17.8241C7.31618 18.2584 6.69737 18.8745 5.93805 19.4968C5.13832 20.154 3.45483 19.8761 3.04454 18.4781C2.93494 18.0986 2.96028 17.729 3.04499 17.4357C3.48718 16.0765 3.8247 15.722 4.21652 13.8309C4.31511 13.355 4.42778 12.8825 4.54428 12.4251C4.57705 12.3135 4.54455 12.1847 4.45694 12.0982C3.59188 11.3218 2.86406 10.6475 2.38041 10.338C1.56695 9.81751 1.74007 9.45653 0.646835 8.64411C0.615327 8.62069 0.584232 8.59748 0.553532 8.57445C-0.632692 7.61337 0.293359 5.92222 1.40442 5.98602C1.69113 5.9852 1.98724 5.99038 2.31038 5.99894C3.13047 6.02067 5.10626 5.94216 6.68934 5.80704C7.00029 5.78281 7.2434 5.55824 7.31768 5.33067C7.4104 5.0793 7.48611 4.85657 7.5389 4.67475C7.91167 3.39068 8.74681 2.09873 9.15896 1.28382C9.28734 1.03 9.399 0.834712 9.49145 0.687881C9.53062 0.62569 9.56671 0.604521 9.5895 0.614092C9.58951 0.614099 9.58953 0.614105 9.58954 0.614111C9.6179 0.626078 9.62563 0.685696 9.59305 0.773112C9.43488 1.19744 9.2184 1.83999 9.0113 2.61956C8.66045 3.94022 8.40126 4.11114 7.84537 5.55284C7.77062 5.74294 7.64432 5.93521 7.45673 6.0939C7.24839 6.27042 6.994 6.37696 6.73706 6.40957C5.07275 6.65306 3.89775 6.90653 1.76865 6.95057C1.66979 6.95261 1.5742 6.95565 1.48152 6.95959C1.21618 6.96205 1.06846 7.16057 1.05355 7.34539C1.04083 7.53618 1.13776 7.6524 1.27599 7.72073C2.0064 8.21788 2.80591 8.7938 4.03029 10.0548C4.48242 10.5205 4.87178 10.8873 5.22448 11.1913C5.70209 11.6013 5.85889 12.2075 5.75946 12.7185C5.56373 13.9554 5.60682 14.9041 5.1585 16.9794C5.09374 17.2792 5.02383 17.5853 4.94992 17.8957C4.93945 17.8622 4.93919 17.9193 4.98306 17.9141C6.67929 16.9562 8.37889 16.0554 9.59238 15.3607C10.1504 15.0332 10.7825 15.0639 11.2338 15.2639C11.3019 15.2934 11.3687 15.3274 11.4335 15.3658C12.7029 16.107 14.285 17.0134 15.9686 18.0422C16.0799 18.1399 16.2991 18.0203 16.2997 17.8933C16.301 17.879 16.3008 17.8626 16.2976 17.8428C15.9579 16.2774 15.4911 14.5377 15.0443 12.7728C14.8773 12.129 15.1165 11.4017 15.6251 10.9794C16.3921 10.3263 17.1645 9.6873 17.9311 9.09602C18.4922 8.66333 19.1048 8.18946 19.7361 7.70083C19.9939 7.57687 19.9287 7.06059 19.5433 7.01141C17.5746 6.76817 15.7102 6.53492 14.5794 6.37816C14.482 6.36466 14.3882 6.35165 14.2975 6.3391C13.7443 6.26693 13.3868 5.89067 13.252 5.52408C12.8928 4.54016 12.6384 3.93599 12.0298 2.62909C11.7734 2.0784 11.4911 1.40556 11.2275 0.703302C11.0794 0.206065 10.3519 -0.0166845 9.8889 0.327996C9.64547 0.512407 9.58148 0.649713 9.55042 0.590215C9.52968 0.545058 9.55778 0.28758 9.86716 0.0414097C10.5522 -0.475093 11.4501 -0.0125578 11.6591 0.521626C11.7481 0.692592 11.836 0.840255 11.9287 0.958954C12.5707 1.78133 12.8331 2.13524 13.1802 3.36853C13.4317 4.26215 13.7975 4.72467 14.0747 5.17764C14.13 5.22846 14.1792 5.25589 14.226 5.30064C14.2713 5.34157 14.3094 5.37789 14.3712 5.40787C14.8496 5.51524 15.5559 5.65704 18.3516 5.75657C18.8047 5.7727 19.2332 5.78864 19.6389 5.80434C21.2538 5.85856 21.6725 8.03986 20.641 8.77015C19.4421 9.85577 18.6007 10.6008 17.9443 11.188C17.6266 11.4724 17.1901 11.8309 16.6881 12.2354C16.6384 12.266 16.6014 12.3254 16.6074 12.3954C16.8761 13.6606 17.1802 15.0805 17.511 16.2966C17.6045 16.6403 17.7082 17.0394 17.819 17.4755C18.2724 18.7933 16.5019 20.3254 15.1315 19.4295C13.425 18.4081 11.6243 17.326 10.5865 16.7695C10.5807 16.7684 10.5752 16.7679 10.5699 16.7678C10.5133 16.769 10.4837 16.7885 10.4597 16.7979C9.6041 17.2982 9.29445 17.2862 8.19994 17.8241Z" fill="#AE2220"/>
                    <path d="M32.1999 17.8241C31.3161 18.2584 30.6973 18.8745 29.938 19.4968C29.1383 20.154 27.4548 19.8761 27.0445 18.4781C26.9349 18.0986 26.9602 17.729 27.0449 17.4357C27.4871 16.0765 27.8246 15.722 28.2165 13.8309C28.315 13.355 28.4277 12.8825 28.5442 12.4251C28.577 12.3135 28.5445 12.1847 28.4569 12.0982C27.5918 11.3218 26.864 10.6475 26.3803 10.338C25.5669 9.81751 25.74 9.45653 24.6468 8.64411C24.6153 8.62069 24.5842 8.59748 24.5535 8.57445C23.3672 7.61337 24.2933 5.92222 25.4044 5.98602C25.6911 5.9852 25.9872 5.99038 26.3103 5.99894C27.1304 6.02067 29.1062 5.94216 30.6893 5.80704C31.0002 5.78281 31.2433 5.55824 31.3176 5.33067C31.4103 5.0793 31.4861 4.85657 31.5388 4.67475C31.9116 3.39068 32.7468 2.09873 33.1589 1.28382C33.2873 1.03 33.3989 0.834712 33.4914 0.687881C33.5306 0.62569 33.5666 0.604521 33.5894 0.614092C33.5894 0.614099 33.5895 0.614105 33.5895 0.614111C33.6178 0.626078 33.6256 0.685696 33.593 0.773112C33.4348 1.19744 33.2183 1.83999 33.0112 2.61956C32.6604 3.94022 32.4012 4.11114 31.8453 5.55284C31.7706 5.74294 31.6443 5.93521 31.4567 6.0939C31.2483 6.27042 30.9939 6.37696 30.737 6.40957C29.0727 6.65306 27.8977 6.90653 25.7686 6.95057C25.6697 6.95261 25.5741 6.95565 25.4815 6.95959C25.2161 6.96205 25.0684 7.16057 25.0535 7.34539C25.0408 7.53618 25.1377 7.6524 25.2759 7.72073C26.0063 8.21788 26.8058 8.7938 28.0302 10.0548C28.4824 10.5205 28.8717 10.8873 29.2244 11.1913C29.702 11.6013 29.8588 12.2075 29.7594 12.7185C29.5637 13.9554 29.6068 14.9041 29.1584 16.9794C29.0937 17.2792 29.0238 17.5853 28.9499 17.8957C28.9394 17.8622 28.9391 17.9193 28.983 17.9141C30.6792 16.9562 32.3788 16.0554 33.5923 15.3607C34.1503 15.0332 34.7824 15.0639 35.2337 15.2639C35.3018 15.2934 35.3687 15.3274 35.4334 15.3658C36.7029 16.107 38.285 17.0134 39.9685 18.0422C40.0798 18.1399 40.299 18.0203 40.2996 17.8933C40.301 17.879 40.3007 17.8626 40.2976 17.8428C39.9578 16.2774 39.491 14.5377 39.0442 12.7728C38.8772 12.129 39.1164 11.4017 39.625 10.9794C40.392 10.3263 41.1645 9.6873 41.9311 9.09602C42.4921 8.66333 43.1047 8.18946 43.736 7.70083C43.9938 7.57687 43.9286 7.06059 43.5432 7.01141C41.5745 6.76817 39.7101 6.53492 38.5794 6.37816C38.482 6.36466 38.3881 6.35165 38.2974 6.3391C37.7442 6.26693 37.3867 5.89067 37.2519 5.52408C36.8927 4.54016 36.6383 3.93599 36.0298 2.62909C35.7734 2.0784 35.4911 1.40556 35.2275 0.703302C35.0793 0.206065 34.3519 -0.0166845 33.8888 0.327996C33.6454 0.512407 33.5814 0.649713 33.5504 0.590215C33.5296 0.545058 33.5577 0.28758 33.8671 0.0414097C34.5521 -0.475093 35.45 -0.0125578 35.659 0.521626C35.748 0.692592 35.836 0.840255 35.9286 0.958954C36.5706 1.78133 36.8331 2.13524 37.1801 3.36853C37.4316 4.26215 37.7974 4.72467 38.0746 5.17764C38.1299 5.22846 38.1792 5.25589 38.226 5.30064C38.2712 5.34157 38.3094 5.37789 38.3712 5.40787C38.8496 5.51524 39.5558 5.65704 42.3515 5.75657C42.8047 5.7727 43.2331 5.78864 43.6388 5.80434C45.2538 5.85856 45.6724 8.03986 44.6409 8.77015C43.442 9.85577 42.6007 10.6008 41.9443 11.188C41.6265 11.4724 41.1901 11.8309 40.688 12.2354C40.6384 12.266 40.6013 12.3254 40.6074 12.3954C40.876 13.6606 41.1802 15.0805 41.5109 16.2966C41.6044 16.6403 41.7082 17.0394 41.8189 17.4755C42.2723 18.7933 40.5018 20.3254 39.1315 19.4295C37.425 18.4081 35.6243 17.326 34.5864 16.7695C34.5807 16.7684 34.5751 16.7679 34.5698 16.7678C34.5132 16.769 34.4836 16.7885 34.4596 16.7979C33.604 17.2982 33.2944 17.2862 32.1999 17.8241Z" fill="#AE2220"/>
                    <path d="M56.1999 17.8241C55.3161 18.2584 54.6973 18.8745 53.938 19.4968C53.1382 20.154 51.4547 19.8761 51.0444 18.4781C50.9348 18.0986 50.9602 17.729 51.0449 17.4357C51.4871 16.0765 51.8246 15.722 52.2164 13.8309C52.315 13.355 52.4277 12.8825 52.5442 12.4251C52.577 12.3135 52.5445 12.1847 52.4568 12.0982C51.5918 11.3218 50.864 10.6475 50.3803 10.338C49.5669 9.81751 49.74 9.45653 48.6467 8.64411C48.6152 8.62069 48.5841 8.59748 48.5534 8.57445C47.3672 7.61337 48.2933 5.92222 49.4043 5.98602C49.691 5.9852 49.9871 5.99038 50.3103 5.99894C51.1304 6.02067 53.1062 5.94216 54.6892 5.80704C55.0002 5.78281 55.2433 5.55824 55.3176 5.33067C55.4103 5.0793 55.486 4.85657 55.5388 4.67475C55.9116 3.39068 56.7467 2.09873 57.1589 1.28382C57.2873 1.03 57.3989 0.834712 57.4914 0.687881C57.5305 0.62569 57.5666 0.604521 57.5894 0.614092C57.5894 0.614099 57.5894 0.614105 57.5894 0.614111C57.6178 0.626078 57.6255 0.685696 57.593 0.773112C57.4348 1.19744 57.2183 1.83999 57.0112 2.61956C56.6604 3.94022 56.4012 4.11114 55.8453 5.55284C55.7705 5.74294 55.6442 5.93521 55.4566 6.0939C55.2483 6.27042 54.9939 6.37696 54.737 6.40957C53.0727 6.65306 51.8977 6.90653 49.7686 6.95057C49.6697 6.95261 49.5741 6.95565 49.4814 6.95959C49.2161 6.96205 49.0684 7.16057 49.0535 7.34539C49.0407 7.53618 49.1377 7.6524 49.2759 7.72073C50.0063 8.21788 50.8058 8.7938 52.0302 10.0548C52.4823 10.5205 52.8717 10.8873 53.2244 11.1913C53.702 11.6013 53.8588 12.2075 53.7594 12.7185C53.5636 13.9554 53.6067 14.9041 53.1584 16.9794C53.0936 17.2792 53.0237 17.5853 52.9498 17.8957C52.9394 17.8622 52.9391 17.9193 52.983 17.9141C54.6792 16.9562 56.3788 16.0554 57.5923 15.3607C58.1503 15.0332 58.7824 15.0639 59.2337 15.2639C59.3018 15.2934 59.3686 15.3274 59.4334 15.3658C60.7028 16.107 62.2849 17.0134 63.9685 18.0422C64.0798 18.1399 64.299 18.0203 64.2996 17.8933C64.3009 17.879 64.3007 17.8626 64.2975 17.8428C63.9578 16.2774 63.491 14.5377 63.0442 12.7728C62.8772 12.129 63.1164 11.4017 63.625 10.9794C64.392 10.3263 65.1644 9.6873 65.9311 9.09602C66.4921 8.66333 67.1047 8.18946 67.736 7.70083C67.9938 7.57687 67.9286 7.06059 67.5432 7.01141C65.5745 6.76817 63.7101 6.53492 62.5793 6.37816C62.4819 6.36466 62.3881 6.35165 62.2974 6.3391C61.7442 6.26693 61.3867 5.89067 61.2519 5.52408C60.8927 4.54016 60.6383 3.93599 60.0297 2.62909C59.7733 2.0784 59.491 1.40556 59.2274 0.703302C59.0793 0.206065 58.3518 -0.0166845 57.8888 0.327996C57.6454 0.512407 57.5814 0.649713 57.5503 0.590215C57.5296 0.545058 57.5577 0.28758 57.8671 0.0414097C58.5521 -0.475093 59.45 -0.0125578 59.659 0.521626C59.748 0.692592 59.8359 0.840255 59.9286 0.958954C60.5706 1.78133 60.833 2.13524 61.1801 3.36853C61.4316 4.26215 61.7974 4.72467 62.0746 5.17764C62.1299 5.22846 62.1792 5.25589 62.226 5.30064C62.2712 5.34157 62.3093 5.37789 62.3711 5.40787C62.8495 5.51524 63.5558 5.65704 66.3515 5.75657C66.8046 5.7727 67.2331 5.78864 67.6388 5.80434C69.2537 5.85856 69.6724 8.03986 68.6409 8.77015C67.442 9.85577 66.6006 10.6008 65.9443 11.188C65.6265 11.4724 65.19 11.8309 64.688 12.2354C64.6383 12.266 64.6013 12.3254 64.6073 12.3954C64.876 13.6606 65.1801 15.0805 65.5109 16.2966C65.6044 16.6403 65.7081 17.0394 65.8189 17.4755C66.2723 18.7933 64.5018 20.3254 63.1314 19.4295C61.4249 18.4081 59.6242 17.326 58.5864 16.7695C58.5806 16.7684 58.5751 16.7679 58.5698 16.7678C58.5132 16.769 58.4836 16.7885 58.4596 16.7979C57.604 17.2982 57.2944 17.2862 56.1999 17.8241Z" fill="#AE2220"/>
                    <path d="M80.1998 17.8241C79.3161 18.2584 78.6973 18.8745 77.9379 19.4968C77.1382 20.154 75.4547 19.8761 75.0444 18.4781C74.9348 18.0986 74.9602 17.729 75.0449 17.4357C75.4871 16.0765 75.8246 15.722 76.2164 13.8309C76.315 13.355 76.4277 12.8825 76.5442 12.4251C76.5769 12.3135 76.5444 12.1847 76.4568 12.0982C75.5918 11.3218 74.8639 10.6475 74.3803 10.338C73.5668 9.81751 73.74 9.45653 72.6467 8.64411C72.6152 8.62069 72.5841 8.59748 72.5534 8.57445C71.3672 7.61337 72.2932 5.92222 73.4043 5.98602C73.691 5.9852 73.9871 5.99038 74.3103 5.99894C75.1303 6.02067 77.1061 5.94216 78.6892 5.80704C79.0002 5.78281 79.2433 5.55824 79.3176 5.33067C79.4103 5.0793 79.486 4.85657 79.5388 4.67475C79.9116 3.39068 80.7467 2.09873 81.1588 1.28382C81.2872 1.03 81.3989 0.834712 81.4913 0.687881C81.5305 0.62569 81.5666 0.604521 81.5894 0.614092C81.5894 0.614099 81.5894 0.614105 81.5894 0.614111C81.6178 0.626078 81.6255 0.685696 81.5929 0.773112C81.4348 1.19744 81.2183 1.83999 81.0112 2.61956C80.6603 3.94022 80.4011 4.11114 79.8452 5.55284C79.7705 5.74294 79.6442 5.93521 79.4566 6.0939C79.2483 6.27042 78.9939 6.37696 78.7369 6.40957C77.0726 6.65306 75.8976 6.90653 73.7685 6.95057C73.6697 6.95261 73.5741 6.95565 73.4814 6.95959C73.2161 6.96205 73.0683 7.16057 73.0534 7.34539C73.0407 7.53618 73.1376 7.6524 73.2759 7.72073C74.0063 8.21788 74.8058 8.7938 76.0302 10.0548C76.4823 10.5205 76.8717 10.8873 77.2244 11.1913C77.702 11.6013 77.8588 12.2075 77.7593 12.7185C77.5636 13.9554 77.6067 14.9041 77.1584 16.9794C77.0936 17.2792 77.0237 17.5853 76.9498 17.8957C76.9393 17.8622 76.9391 17.9193 76.9829 17.9141C78.6792 16.9562 80.3788 16.0554 81.5923 15.3607C82.1503 15.0332 82.7823 15.0639 83.2337 15.2639C83.3018 15.2934 83.3686 15.3274 83.4334 15.3658C84.7028 16.107 86.2849 17.0134 87.9685 18.0422C88.0798 18.1399 88.2989 18.0203 88.2995 17.8933C88.3009 17.879 88.3006 17.8626 88.2975 17.8428C87.9578 16.2774 87.491 14.5377 87.0442 12.7728C86.8772 12.129 87.1164 11.4017 87.625 10.9794C88.3919 10.3263 89.1644 9.6873 89.931 9.09602C90.492 8.66333 91.1046 8.18946 91.7359 7.70083C91.9938 7.57687 91.9286 7.06059 91.5431 7.01141C89.5744 6.76817 87.7101 6.53492 86.5793 6.37816C86.4819 6.36466 86.388 6.35165 86.2974 6.3391C85.7441 6.26693 85.3866 5.89067 85.2518 5.52408C84.8927 4.54016 84.6383 3.93599 84.0297 2.62909C83.7733 2.0784 83.491 1.40556 83.2274 0.703302C83.0793 0.206065 82.3518 -0.0166845 81.8888 0.327996C81.6453 0.512407 81.5814 0.649713 81.5503 0.590215C81.5296 0.545058 81.5577 0.28758 81.867 0.0414097C82.5521 -0.475093 83.45 -0.0125578 83.6589 0.521626C83.748 0.692592 83.8359 0.840255 83.9286 0.958954C84.5705 1.78133 84.833 2.13524 85.1801 3.36853C85.4316 4.26215 85.7973 4.72467 86.0746 5.17764C86.1299 5.22846 86.1791 5.25589 86.2259 5.30064C86.2711 5.34157 86.3093 5.37789 86.3711 5.40787C86.8495 5.51524 87.5557 5.65704 90.3514 5.75657C90.8046 5.7727 91.2331 5.78864 91.6387 5.80434C93.2537 5.85856 93.6724 8.03986 92.6408 8.77015C91.442 9.85577 90.6006 10.6008 89.9442 11.188C89.6264 11.4724 89.19 11.8309 88.688 12.2354C88.6383 12.266 88.6013 12.3254 88.6073 12.3954C88.8759 13.6606 89.1801 15.0805 89.5109 16.2966C89.6043 16.6403 89.7081 17.0394 89.8188 17.4755C90.2723 18.7933 88.5017 20.3254 87.1314 19.4295C85.4249 18.4081 83.6242 17.326 82.5864 16.7695C82.5806 16.7684 82.5751 16.7679 82.5698 16.7678C82.5132 16.769 82.4835 16.7885 82.4595 16.7979C81.604 17.2982 81.2943 17.2862 80.1998 17.8241Z" fill="#AE2220"/>
                    <path d="M104.2 17.8241C103.316 18.2584 102.697 18.8745 101.938 19.4968C101.138 20.154 99.4546 19.8761 99.0444 18.4781C98.9348 18.0986 98.9601 17.729 99.0448 17.4357C99.487 16.0765 99.8245 15.722 100.216 13.8309C100.315 13.355 100.428 12.8825 100.544 12.4251C100.577 12.3135 100.544 12.1847 100.457 12.0982C99.5917 11.3218 98.8639 10.6475 98.3802 10.338C97.5668 9.81751 97.7399 9.45653 96.6467 8.64411C96.6151 8.62069 96.584 8.59748 96.5533 8.57445C95.3671 7.61337 96.2932 5.92222 97.4042 5.98602C97.691 5.9852 97.9871 5.99038 98.3102 5.99894C99.1303 6.02067 101.106 5.94216 102.689 5.80704C103 5.78281 103.243 5.55824 103.317 5.33067C103.41 5.0793 103.486 4.85657 103.539 4.67475C103.911 3.39068 104.747 2.09873 105.159 1.28382C105.287 1.03 105.399 0.834712 105.491 0.687881C105.53 0.62569 105.567 0.604521 105.589 0.614092C105.589 0.614099 105.589 0.614105 105.589 0.614111C105.618 0.626078 105.625 0.685696 105.593 0.773112C105.435 1.19744 105.218 1.83999 105.011 2.61956C104.66 3.94022 104.401 4.11114 103.845 5.55284C103.77 5.74294 103.644 5.93521 103.457 6.0939C103.248 6.27042 102.994 6.37696 102.737 6.40957C101.073 6.65306 99.8976 6.90653 97.7685 6.95057C97.6696 6.95261 97.574 6.95565 97.4813 6.95959C97.216 6.96205 97.0683 7.16057 97.0534 7.34539C97.0407 7.53618 97.1376 7.6524 97.2758 7.72073C98.0062 8.21788 98.8057 8.7938 100.03 10.0548C100.482 10.5205 100.872 10.8873 101.224 11.1913C101.702 11.6013 101.859 12.2075 101.759 12.7185C101.564 13.9554 101.607 14.9041 101.158 16.9794C101.094 17.2792 101.024 17.5853 100.95 17.8957C100.939 17.8622 100.939 17.9193 100.983 17.9141C102.679 16.9562 104.379 16.0554 105.592 15.3607C106.15 15.0332 106.782 15.0639 107.234 15.2639C107.302 15.2934 107.369 15.3274 107.433 15.3658C108.703 16.107 110.285 17.0134 111.968 18.0422C112.08 18.1399 112.299 18.0203 112.299 17.8933C112.301 17.879 112.301 17.8626 112.297 17.8428C111.958 16.2774 111.491 14.5377 111.044 12.7728C110.877 12.129 111.116 11.4017 111.625 10.9794C112.392 10.3263 113.164 9.6873 113.931 9.09602C114.492 8.66333 115.105 8.18946 115.736 7.70083C115.994 7.57687 115.928 7.06059 115.543 7.01141C113.574 6.76817 111.71 6.53492 110.579 6.37816C110.482 6.36466 110.388 6.35165 110.297 6.3391C109.744 6.26693 109.387 5.89067 109.252 5.52408C108.893 4.54016 108.638 3.93599 108.03 2.62909C107.773 2.0784 107.491 1.40556 107.227 0.703302C107.079 0.206065 106.352 -0.0166845 105.889 0.327996C105.645 0.512407 105.581 0.649713 105.55 0.590215C105.529 0.545058 105.558 0.28758 105.867 0.0414097C106.552 -0.475093 107.45 -0.0125578 107.659 0.521626C107.748 0.692592 107.836 0.840255 107.928 0.958954C108.57 1.78133 108.833 2.13524 109.18 3.36853C109.432 4.26215 109.797 4.72467 110.075 5.17764C110.13 5.22846 110.179 5.25589 110.226 5.30064C110.271 5.34157 110.309 5.37789 110.371 5.40787C110.849 5.51524 111.556 5.65704 114.351 5.75657C114.805 5.7727 115.233 5.78864 115.639 5.80434C117.254 5.85856 117.672 8.03986 116.641 8.77015C115.442 9.85577 114.601 10.6008 113.944 11.188C113.626 11.4724 113.19 11.8309 112.688 12.2354C112.638 12.266 112.601 12.3254 112.607 12.3954C112.876 13.6606 113.18 15.0805 113.511 16.2966C113.604 16.6403 113.708 17.0394 113.819 17.4755C114.272 18.7933 112.502 20.3254 111.131 19.4295C109.425 18.4081 107.624 17.326 106.586 16.7695C106.581 16.7684 106.575 16.7679 106.57 16.7678C106.513 16.769 106.483 16.7885 106.459 16.7979C105.604 17.2982 105.294 17.2862 104.2 17.8241Z" fill="#AE2220"/>
                  </svg>

                  <div className="relative p-6 mb-4 bg-white rounded-2xl shadow-soft">
                    <p className="italic leading-normal font-body text-body-md text-text-secondary">"{testimonial.quote}"</p>
                    {/* Triangle pointer */}
                    <div className="absolute bottom-0 transform -translate-x-1/2 translate-y-full left-1/2">
                      <div className="w-0 h-0 border-l-[10px] border-r-[10px] border-t-[10px] border-l-transparent border-r-transparent border-t-white"></div>
                    </div>
                  </div>
                  
                  {/* Second Sub Card - Person Info */}
                  <div className="p-4 bg-transparent border-2 border-primary/20 rounded-2xl">
                    {/* Profile Image - Centered above name */}
                    <div className="flex justify-center mb-3">
                      {testimonial.photo ? (
                        <img 
                          src={testimonial.photo} 
                          alt={testimonial.name} 
                          className="object-cover w-16 h-16 rounded-full" 
                          onError={(e) => {
                            console.error('Testimonial photo failed to load:', e.target.src);
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                          }}
                        />
                      ) : (
                        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-primary/10">
                          <span className="text-lg font-bold text-primary font-heading">{testimonial.name?.[0]}</span>
                        </div>
                      )}
                    </div>
                    {/* Name and Position - Centered */}
                    <div className="mb-3 text-center">
                      <div className="text-sm font-bold font-body text-text-primary">{testimonial.name}</div>
                      <div className="font-body text-body-xs text-text-secondary">{testimonial.position}</div>
                      {testimonial.company && (
                        <div className="font-body text-body-xs text-text-secondary">{testimonial.company}</div>
                      )}
                    </div>
                    {testimonial.company_logo && (
                      <div className="flex justify-center">
                        <img 
                          src={testimonial.company_logo} 
                          alt={`${testimonial.company} logo`} 
                          className="object-contain h-8" 
                          onError={(e) => {
                            console.error('Company logo failed to load:', e.target.src);
                            e.target.parentElement.style.display = 'none';
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>

          <div className="text-center mobile-stack md:grid md:grid-cols-3">
            {loading ? (
              Array.from({ length: 3 }).map((_, idx) => (
                <div key={idx} className="animate-pulse">
                  <div className="h-12 bg-gray-200 rounded"></div>
                  <div className="h-5 bg-gray-200 rounded"></div>
                </div>
              ))
            ) : (
              homepageData.testimonial_stats.map((stat) => (
                <div key={stat.id ?? stat.label}>
                  <div className="mb-2 text-5xl font-bold font-heading text-primary">{stat.number}</div>
                  <p className="font-body text-body-sm text-text-secondary">{stat.label}</p>
                </div>
              ))
            )}
          </div>
        </div>
      </section>

      {/* Strong Partnerships - Golden Background */}
      <section className="relative py-20 overflow-hidden">
        <div className="relative z-10 px-6 mx-auto max-w-7xl lg:px-8">
          <div className="flex flex-col items-center gap-12 lg:flex-row">
            <div className="flex-1 text-white">
              <h2 className="mb-4 font-heading text-heading-lg text-text-primary">Strong Partnerships.<br/>Strong Performance.</h2>
              <p className="mb-8 leading-normal font-body text-body-lg text-text-primary/90">
                At Enessa Foods, we believe in building lasting partnerships with renowned bakeries and innovators across India, ensuring you get the best solutions and unmatched service. Choose us for a no-risk partnership focused on growing your business.
              </p>
              <div className="flex gap-4 ml-16">
                <Link to="/contact">
                  <Button variant="primary" size="medium">Contact Us</Button>
                </Link>
                <Link to="/about">
                  <Button variant="secondary" size="medium">About Us</Button>
                </Link>
              </div>
            </div>
            <div className="flex-1">
              <img src={imagePlaceholder} alt="Partnership" className="object-cover w-full shadow-2xl h-96 rounded-3xl" />
            </div>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="py-20 bg-white lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="mb-12 text-center">
            <div className="mb-3 font-semibold tracking-wider uppercase font-body text-body-xs text-primary">📚 Blogs</div>
            <h2 className="mb-4 font-heading text-heading-lg text-text-primary">Insights That Rise Like Dough</h2>
            <p className="font-body text-body-md text-text-secondary">Stay ahead with our expert articles on baking trends, innovations & industry tips.</p>
          </div>

          {/* Featured Posts */}
          {(homepageData.blogs || []).length > 0 ? (
            <div className="grid gap-4 lg:grid-cols-2">
              {/* Main Featured Post - Left Column */}
              <div className="overflow-hidden rounded-3xl">
                <img 
                  src={homepageData.blogs[0]?.image || '/assets/images/blogs/featured.jpg'} 
                  alt={homepageData.blogs[0]?.title} 
                  className="object-cover w-full h-80" 
                />
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="flex items-start px-2 py-1 text-sm font-medium bg-white rounded-lg text-text-primary">{homepageData.blogs[0]?.category}</span>
                    <span className="text-sm text-text-primary">• {homepageData.blogs[0]?.time || '20 min read'}</span>
                  </div>
                  <h3 className="mb-4 text-[32px] leading-[130%] capitalize" style={{fontFamily: 'Dream Orphanage', fontWeight: 400, color: '#561110'}}>
                    {homepageData.blogs[0]?.title || '5 Ways To Improve Bread Quality Without Increasing Costs'}
                  </h3>
                  <p className="mb-4 leading-relaxed text-text-primary">
                    {homepageData.blogs[0]?.excerpt || 'Discover proven techniques to enhance your bread quality while maintaining profitability.'}
                  </p>
                  {homepageData.blogs[0]?.blog_content && (
                    <div className="mb-6 text-text-primary" dangerouslySetInnerHTML={{ __html: homepageData.blogs[0].blog_content }} />
                  )}
                  <Link 
                    to={`/blog/${homepageData.blogs[0]?.id}`} 
                    className="inline-flex items-center gap-2 font-medium text-primary hover:underline"
                  >
                    Read More
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              </div>
              
              {/* Side Featured Posts - Right Column */}
              <div className="space-y-4">
                {(homepageData.blogs || []).slice(1, 4).map((blog, idx) => (
                  <div key={blog.id || idx} className="flex gap-4 p-4 rounded-2xl">
                    <img 
                      src={blog.image} 
                      alt={blog.title} 
                      className="flex-shrink-0 object-cover w-40 h-40 rounded-lg" 
                    />
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="flex items-start px-2 py-1 text-sm font-medium bg-white rounded-lg text-text-primary">{blog.category}</span>
                        <span className="text-sm text-text-primary">• {blog.time}</span>
                      </div>
                      <h4 className="mb-2 text-[32px] leading-[130%] capitalize line-clamp-2" style={{fontFamily: 'Dream Orphanage', fontWeight: 400, color: '#561110'}}>
                        {blog.title}
                      </h4>
                      <Link 
                        to={`/blog/${blog.id}`} 
                        className="inline-flex items-center gap-1 text-xs font-medium text-primary hover:underline"
                      >
                        Read More
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="flex flex-col gap-8 p-8 bg-white lg:bg-cream rounded-3xl lg:p-12 lg:flex-row">
              <div className="flex-1">
                <img src={doughImg} alt="Featured" className="object-cover w-full shadow-lg h-80 rounded-2xl" />
              </div>
              <div className="flex flex-col justify-center flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="flex items-start px-2 py-1 text-sm font-medium bg-white rounded-lg text-text-primary">Featured</span>
                  <span className="text-sm text-text-primary">• 20 min read</span>
                </div>
                <h3 className="mb-4 text-3xl font-bold text-text-primary">5 Ways To Improve Bread Quality Without Increasing Costs</h3>
                <p className="mb-6 leading-relaxed text-text-primary">Discover proven techniques to enhance your bread quality while maintaining profitability. From ingredient optimization to process improvements, we cover everything you need to know.</p>
                <Link to="/blogs" className="inline-flex items-center gap-2 px-6 py-3 text-white transition-all rounded-full bg-primary hover:bg-primary/90">
                  Read More
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Final CTA with Chef */}
      <section className="py-24 bg-white lg:py-40 lg:bg-cream">
        <div className="px-6 mx-auto bg-white lg:bg-cream max-w-7xl lg:px-8">
          <div className="bg-white rounded-[40px] p-12 lg:p-24 shadow-soft flex flex-col lg:flex-row-reverse items-center gap-16">
            <div className="flex-1">
              <img src={bottomChef} alt="Chef" className="w-full shadow-2xl rounded-3xl" />
            </div>
            <div className="flex-1 text-center bg-white lg:text-left">
              <h2 className="mb-8 leading-tight font-heading text-heading-lg text-text-primary">
                Ready To Take Your Bakery To<br className="hidden lg:block" /> The Next Level?
              </h2>
              <p className="mb-10 leading-normal font-body text-body-lg text-text-primary">
                Contact a Enessa Foods expert service team today. We work with you to understand your needs and create a tailor-made solution that boosts quality, efficiency, and profitability.
              </p>
              <div className="flex flex-wrap justify-center gap-6 lg:justify-start">
                <Link to="/contact"><Button variant="primary" size="large">Contact Us</Button></Link>
                <Link to="/contact#inquiry-section"><Button variant="secondary" size="large">Enquiry Form</Button></Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Homepage;